/* Declaration here to suppress TS/ESlint errors in isIE function. */
declare global {
  interface Document {
    documentMode?: number;
  }

  interface Window {
    msCrypto?: any;
  }
}

/*
    checks whether IE is in use by duck typing/feature detection.
    first conditional: checks for JSscript's conditional compilation, featured up until IE9.
    second conditional: a value returned here indicates the version of IE used to render the current document, from 5-11.
    third conditional: msCrypto is a prefixed version of the window.crypto only implemented in IE11.
  */
export const isIE = () => /*@cc_on!@*/ false || !!document.documentMode || !!window.msCrypto;
